/**
 *
 * @param {boolean} showCalender
 * @param {function} setShowCalender
 * @returns {function}
 */
export const showCal = (showCalender, setShowCalender) => {
  return () => setShowCalender(!showCalender);
};
